module.exports = __webpack_public_path__ + "static/media/Rebecca-Smith.c44c8090.jpg";